<template>
  <div>
    <div class="d-flex justify-content-start">
      <div id="grid"></div>
      <div class="d-flex">
<!--                        <button @click="kek">button</button>-->
        <b-button
          style="box-shadow:none;"
          v-if="authorizedGoogle"

          @click="getSheetsList"
          size="sm"
          class="btn-danger  mr-2"
        >
          {{ sheetName ? `Connected to ${sheetName}` : 'G'}}
        </b-button>
        <b-button
          v-else
           style="box-shadow:none;"
          @click="googleAuth"
          size="sm"
          class="btn-success  mr-2"
        >
          <i class="fab fa-google"></i>
        </b-button>
      </div>
    </div>
    <b-modal
      ref="sheetModal"
      title="Chose Google Sheet to load data"
      @ok="getData"
    >
      <div class="d-block text-center">
        <model-list-select 
          :list="sheetsList"
          v-model="sheetId"
          option-value="id"
          option-text="name"
          placeholder="-- Please select a Google Sheet --"
        />
        <b-form-checkbox
          class="mt-4 text-left"
          v-model="watchForFile"
          :value="true"
          :unchecked-value="false"
        >
          Watch changes from the file
        </b-form-checkbox>
        <b-form-checkbox
          class="mt-4 text-left"
          v-model="removeDataFromGrid"
          :value="true"
          :unchecked-value="false"
        >
          Remove data from grid
        </b-form-checkbox>
      </div>
    </b-modal>
  </div>
</template>
<script>
  import db from '@/services/db'
  import axios from 'axios'
  import _ from 'lodash'
  import { ModelListSelect } from 'vue-search-select'
  import { mapState } from 'vuex'

  const baseUrl = 'https://us-central1-tangle-157402.cloudfunctions.net'
  // const baseUrl = 'http://localhost:5000/tangle-157402/us-central1'

  const codes = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')
  const getCodes = (firstCellIdx, lastCellIdx) => {
    const parseCellIndex = (indexes) => {
      return `${codes[indexes[0]]}${indexes[1] + 1}`
    }
    if (lastCellIdx) {
      return `${parseCellIndex(firstCellIdx)}:${parseCellIndex(lastCellIdx)}`
    } else {
      return parseCellIndex(firstCellIdx)
    }
  }

  export default {
    name: 'GoogleSheets',
    props: {
      options: {
        type: Object,
      },
      gridId: {
        type: String,
      }
    },
    components: {
      ModelListSelect
    },
    data () {
      return {
        sheetId: null,
        connectedToGoogleSheet: '',
        sheetsList: [],
        authorizedGoogle: false,
        sheetData: {},
        sheetName: '',
        stopWatch: true,
        error: '',
        bouncer: null,
        unWatch: null,
        watchForFile: false,
        removeDataFromGrid: false,
        uid: window.fbUser.uid,
      }
    },
    computed: {
      ...mapState([
        'dataGrid_options',
      ]),
      lookUpCols () {
        const keys = []
        _.filter(this.options.meta, (item, key) => {
          if (item.type === 'lookup') {
            keys.push(key)
          }
        })
        return keys
      }
    },
    methods: {
      watchChanges (nv) {
        if ((nv.gridId && nv.gridId !== this.gridId) || !this.connectedToGoogleSheet || this.stopWatch) {
          return
        }
        if (nv.type === 'ColChange') {
          this.updateCol(nv)
        } else if (nv.type === 'RowChange') {
          this.updateRow(nv)
        } else if (nv.type === 'CellChange') {
          this.updateCell(nv)
        }
      },
      async getLookUpValue (index, rowId) {
        const gridId = this.options.meta[this.lookUpCols[index]].lookUpTable

        let displayKey = await db.getRef(`widgetsData/dataGrid/${gridId}/displayColumn`).once('value')
        displayKey = displayKey.val()

        const value = await db.dataGrid.data.getReadModel(this.options.storageType)(gridId)[rowId][displayKey]
        return value
      },

      async upateColsOrder (cols) {
        for (let i = 0; i < cols.length; i++) {
          await db.getRef(`widgetsData/dataGrid/${this.gridId}/meta/${cols[i]}/order`).set(i)
        }
      },
      multiLookupIterator(multiElem, getGrid, displayColumn, lookUpTable){
        return new Promise((resolve, reject) => {
          let lookupObj = getGrid.find(lookup => lookup[displayColumn] == multiElem)
          if(lookupObj){
            resolve(lookupObj.rowKey)
          }else{
            let itemToCreate = {}
            itemToCreate[displayColumn] = multiElem
            $dgAddRow(lookUpTable, itemToCreate)
            .then(rowKey => {
              let getGrid = $getGrid(lookUpTable)
              let lookupValue = getGrid.find(lookup => lookup[displayColumn] == multiElem)
              resolve(lookupValue.rowKey)
            })
          }
        })
      },
      async buildGrid () {
        const setModel = db.dataGrid.data.getWriteModel(this.options.storageType)
        const currentGrid = [...this.$store.getters.$getGrid(this.gridId)]
        this.stopWatch = true
        
        if(this.removeDataFromGrid){
          for (let i = 0; i < currentGrid.length; i++) {
            const pathToModel = `${this.options.source}/${currentGrid[i].rowKey}`
            await setModel(pathToModel, null).then(() => {
              this.$store.dispatch('dataGrid_logRowChange', {
                gridId: this.gridId,
                rowKey: currentGrid[i].rowKey,
                value: null
              })
            })
          }
        }

        const decapitalize = (str) => {
          const splitted = str.split(/(?=[A-Z])/)
          if (splitted.length) {
            return splitted.join(' ')
          } else {
            return false
          }
        }

        const allCols = _.union(this.sheetData.cols, Object.keys(this.options.meta))

        // console.log(_.intersection(this.sheetData.cols, Object.keys(this.options.meta)))
        const diffCols = _.difference(Object.keys(this.options.meta), this.sheetData.cols)

        // db.dataGrid.data.removeMeta(this.gridId)

        for (let i = 0; i < this.sheetData.cols.length; i++) {
          let addColumnItem = {
            order: i,
            propertyName: this.sheetData.cols[i],
            type: this.dataGrid_options[this.gridId].meta[[this.sheetData.cols[i]]] 
            ? this.dataGrid_options[this.gridId].meta[[this.sheetData.cols[i]]].type
            : 'string',
            gridId: this.gridId,
            displayName: decapitalize(this.sheetData.cols[i])
              ? decapitalize(this.sheetData.cols[i])
              : this.sheetData.cols[i],
          }

          if(addColumnItem.type == 'lookup' || addColumnItem.type == 'multi_lookup'){
            addColumnItem['lookUpTable'] = this.dataGrid_options[this.gridId].meta[[this.sheetData.cols[i]]].lookUpTable
          }
          
          await db.dataGrid.data.addColumn(addColumnItem)
        }

        db.dataGrid.data.setAsDisplayColumn(this.gridId, this.sheetData.cols[0])
        const newRows = []
        const rowKeysToSet = ['rowKey']

        for (let i = 0; i < this.sheetData.rows.length; i++) {
          newRows[i] = {}
          this.sheetData.rows[i].forEach((item, index) => {
            const colKey = this.sheetData.cols[index]
            newRows[i][colKey] = item
          })
          const val = newRows[i]
          for (let item in newRows[i]) {
            //console.log(this.dataGrid_options[this.gridId].meta[item].type , 'this.dataGrid_options[this.gridId].meta[item].type ')
            if(this.dataGrid_options[this.gridId].meta[item] 
              && this.dataGrid_options[this.gridId].meta[item].type == 'lookup')
            {
              let lookUpTable = this.dataGrid_options[this.gridId].meta[item].lookUpTable
              let displayColumn = this.dataGrid_options[lookUpTable].displayColumn
              let neededGrid = $getGrid(lookUpTable)
              let neededItem = neededGrid.find(elem => elem[displayColumn] == newRows[i][item])
              if(neededItem){
                val[item] = neededItem.rowKey
              }else{
                let itemToCreate = {}
                itemToCreate[displayColumn] = newRows[i][item].trim()
                let rowKey = await $dgAddRow(lookUpTable, itemToCreate)
                .then(rowKey => {
                  let getGrid = $getGrid(lookUpTable)
                  let lookupValue = getGrid.find(lookup => lookup[displayColumn] == newRows[i][item])
                  return lookupValue.rowKey
                })
                val[item] = rowKey
              }
            }else if(this.dataGrid_options[this.gridId].meta[item] 
              && this.dataGrid_options[this.gridId].meta[item].type == 'multi_lookup')
            {
              let lookUpTable = this.dataGrid_options[this.gridId].meta[item].lookUpTable
              let displayColumn = this.dataGrid_options[lookUpTable].displayColumn
              let neededGrid = $getGrid(lookUpTable)
              let multiLoockupsItems = newRows[i][item].split(',')
              let lookupValue = ''

              for (let index = 0; index < multiLoockupsItems.length; index++) {
                lookupValue += `${await this.multiLookupIterator(multiLoockupsItems[index].trim(), neededGrid, displayColumn, lookUpTable)},`
                if(index == (multiLoockupsItems.length - 1)){
                  val[item] =  lookupValue.slice(0, lookupValue.lastIndexOf(','))
                }
              }
            }          
          }
          const key = await db.dataGrid.data.addRow(this.gridId, val)
          rowKeysToSet.push(key)
          this.$store.dispatch('dataGrid_logRowChange', {
            gridId: this.gridId,
            rowKey: key,
            value: val
          })
        }
        const sheetName = this.sheetsList.find((sheet) => sheet.id === this.sheetId).name
        if (this.watchForFile) {
          db.getRef(`widgetsData/dataGrid/${this.gridId}/googleSheets/connectedToGoogleSheet`).set(this.sheetId)
          db.getRef(`widgetsData/dataGrid/${this.gridId}/googleSheets/watchingForFile`).set(true)
          this.connectedToGoogleSheet = this.sheetId
          if (sheetName) {
            db.getRef(`widgetsData/dataGrid/${this.gridId}/googleSheets/sheetName`).set(sheetName)
          }
        }
        this.sheetName = sheetName
        const colsLength = this.sheetData.cols.length
        const rowsLength = this.sheetData.rows.length
        if (this.watchForFile) {
          await this.writeData(
            {
              action: 'addRowKey',
              dimension: 'COLUMNS',
              range: getCodes([colsLength, 0], [colsLength, rowsLength]),
              values: rowKeysToSet.join(',')
            },
          )
          let interval = 0
          this.bouncer = setInterval(() => {
            interval += 1
            if (interval === 30) {
              this.updateData()
              interval = 0
            }
          }, 1000)

          if (diffCols.length) {
            for (let i = 0; i < diffCols.length; i++) {
              await this.updateCol({
                type: 'ColChange',
                newVal: decapitalize(diffCols[i]).toLowerCase(),
                gridId: this.gridId,
              })
            }
          }
        } else {
          clearInterval(this.bouncer)
        }
        this.$nextTick(() => {
          this.upateColsOrder(allCols)
        })
        this.stopWatch = false
        this.$store.commit('deleteProcess', 'connectGoogleSheet')
      },
      async getSheetsList () {
        this.$store.commit('addProcess', {
          process: 'openGoogleSheet',
          message: 'Opening',
        })
        const resp = await axios.get(`${baseUrl}/googleSheetsList`, {
          params: {
            uid: this.uid
          }
        })
        if (resp.data) {
          this.showFiles(resp.data)
        }
        this.$store.commit('deleteProcess', 'openGoogleSheet')
      },
      showFiles (files) {
        this.sheetsList = files
        this.watchForFile = false
        this.$refs.sheetModal.show()
      },
      async getData () {
        this.$store.commit('addProcess', {
          process: 'connectGoogleSheet',
          message: 'Connecting',
        })
        clearInterval(this.bouncer)
        const resp = await axios.get(`${baseUrl}/getSheetsData`,
          {
            params: {
              dataGridId: this.gridId,
              dashboardId: this.$route.params.id,
              sheetId: this.sheetId,
              uid: this.uid,
              startWatch: true,
              remove: this.removeDataFromGrid ? 'remove' : 'not remove'
            }
          }
        )
        if (resp.data.error) {
          return
        } else if (resp && resp.data) {
          this.sheetData = resp.data
          const rowIndex = this.sheetData.cols.indexOf('rowKey')
          if (rowIndex !== -1) {
            this.sheetData.cols.splice(rowIndex, 1)
            this.sheetData.rows.forEach(el => {
              el.splice(rowIndex, 1)
            })
          }
          this.buildGrid()

          if (this.watchForFile) {
            this.watchFileChanges()
            db.getRef(`widgetsData/dataGrid/${this.gridId}/googleSheets/watchingForFile`).set(true)
          } else {
            clearInterval(this.bouncer)
            db.getRef(`widgetsData/dataGrid/${this.gridId}/googleSheets`).remove()
            this.connectedToGoogleSheet = ''
            this.sheetName = ''
          }

        }
      },
      async removeData (range, action) {
        const resp = await axios.post(`${baseUrl}/removeSheetsData`,
          JSON.stringify({
            uid: this.uid,
            sheetId: this.sheetId,
            range: range,
            action: action
          })
        )
      },
      async writeData (data) {
        return axios.post(`${baseUrl}/writeSheetsData`,
          JSON.stringify({
            uid: this.uid,
            sheetId: this.sheetId,
            action: data.action,
            dimension: data.dimension,
            range: data.range,
            values: data.values
          })
        )
      },
      updateCol (data) {
        if (!data.oldVal && data.newVal) {
          const colsLength = Object.keys(this.options.meta).length
          return this.addNewColumn({
            uid: this.uid,
            sheetId: this.sheetId,
            value: data.newVal
          })
        } else if (data.oldVal && data.newVal) {
          this.writeData({
            action: 'updateCol',
            dimension: 'ROWS',
            values: data.newVal,
            range: {
              col: data.oldVal,
              row: 'first'
            }
          })
        } else if (data.oldVal && !data.newVal) {
          this.removeData({
              row: 'all',
              col: data.oldVal
            },
            'removeCol',
          )
        }
      },
      updateRow (data) {
        if (data.newVal && !this.stopWatch) {
          const payload = {
            ...data,
            action: 'newRow',
            dimension: 'ROWS',
            range: {
              col: 'rowKey',
              row: data.rowKey
            },
            values: data.rowKey
          }
          console.log(payload, 'payload')
          this.writeData(payload)
        } else if (!data.newVal && !this.stopWatch) {
          this.removeData({
              row: JSON.parse(data.oldVal).rowKey,
              col: 'all'
            },
            'removeRow',
          )
        }
      },
      async updateCell (data) {
        const grid = db.dataGrid.data.getReadModel(this.options.storageType)(this.gridId)
        // if (!data.newVal) {
        //   this.removeData({
        //       row: data.rowKey,
        //       col: data.cellKey,
        //     },
        //     'clearCell',)
        //   return
        // } else {

          const lookupIndex = this.lookUpCols.indexOf(data.cellKey)
          let lookUpValue = null
          let lookUpValueToUse = ''
          if (lookupIndex !== -1) {
            lookUpValue = await this.getLookUpValue(lookupIndex, data.newVal)
          }
          if(lookUpValue){
            lookUpValueToUse = lookUpValue
          }else if(data.isLookup){
            lookUpValueToUse = data.oldVal
          }else{
            lookUpValueToUse = data.newVal || ''
          }
          this.writeData({
            action: 'updateCell',
            dimension: 'ROWS',
            values: lookUpValueToUse,
            range: {
              col: data.cellKey,
              row: data.rowKey
            }
          })
        // }
      },
      async addNewColumn (data) {
        return axios.get(`${baseUrl}/addNewColumn`,
          {
            params: data
          })
      },

      async watchFileChanges () {
        const response = await axios.get(`${baseUrl}/watchChanges`,
          {
            params: {
              dataGridId: this.gridId,
              dashboardId: this.$route.params.id,
              sheetId: this.sheetId,
              uid: this.uid
            }
          })
      },

      async googleAuth () {
        db.root.ref('googleAuth/googleAuthFor').set(this.uid)
        const resp = await axios.get(`${baseUrl}/googleSheetsAuth`,
          {
            params: {
              get_url: true
            }
          }
        )
        if (resp.data) {
          window.open(resp.data, 'auth', `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=600,height=500,left=300,top=100`)
        }
        setTimeout(() => {
          this.authorizedGoogle = true
        }, 2000)
      },

      async updateData (sheetId) {
        const response = await axios.get(`${baseUrl}/updateGridFromSheets`,
          {
            params: {
              dataGridId: this.gridId,
              dashboardId: this.$route.params.id,
              uid: this.uid,
              sheetIdParam: sheetId
            }
          }
        )
      }
    },
    async created () {
      db.root.ref(`googleAuth/${this.uid}`)
      .once('value').then((res) => {
        if (res.val()) {
          this.authorizedGoogle = true
        }
      }).catch(err => console.log(err))
      db.getRef(`widgetsData/dataGrid/${this.gridId}/googleSheets/connectedToGoogleSheet`)
      .once('value', (res) => {
        this.connectedToGoogleSheet = res.val()
      })
      db.getRef(`widgetsData/dataGrid/${this.gridId}/googleSheets/sheetsName`)
      .once('value', (res) => {
        this.sheetName = res.val()
      })

      this.unWatch = this.$watch('$store.state.dataGridLogsValue', this.watchChanges, {deep: true})
      if (this.connectedToGoogleSheet) {
        this.sheetId = this.connectedToGoogleSheet
        let watch
        db.getRef(`widgetsData/dataGrid/${this.gridId}/googleSheets/watchingForFile`)
        .once('value', (res) => {
          watch = res.val()
        })
        db.getRef(`widgetsData/dataGrid/${this.gridId}/googleSheets/sheetName`)
        .once('value', (res) => {
          this.sheetName = res.val()
        })

        if (watch) {
          this.updateData()
          this.watchFileChanges()
          let interval = 0
          if (this.bouncer) {
            clearInterval(this.bouncer)
          }
            this.bouncer = null
            this.bouncer = setInterval(() => {
              interval += 1
              if (interval === 30) {
                this.updateData()
                interval = 0
              }
            }, 1000)
        }
      }
      setTimeout(() => {
        this.stopWatch = false
      }, 3000)
    },
    destroyed () {
      // clearInterval(this.bouncer)
    }
  }
</script>
